export const MAIN_SEARCH_MIN_CHARS = 2;

/**
 * Trim and strip one leading `@` (forum muscle memory). `@@foo` becomes `@foo`.
 * @param {*} raw
 * @returns {string}
 */
export const normalizeMainSearchQuery = raw => {
  if (typeof raw !== 'string' && typeof raw !== 'number') {
    return '';
  }
  let value = String(raw).trim();
  if (value.startsWith('@')) {
    value = value.slice(1).trim();
  }
  return value;
};

export const shouldFetchMainSearchSuggestions = normalized =>
  typeof normalized === 'string' && normalized.length >= MAIN_SEARCH_MIN_CHARS;

/**
 * Map combobox highlight to a submit payload.
 * Index 0 is always “search listings”. Seller rows start at index 1.
 * @returns {{ type: 'seller', seller: string } | { type: 'keywords', keywords: string }}
 */
export const resolveMainSearchSubmit = ({
  query,
  activeIndex,
  sellers = [],
  dropdownOpen = false,
} = {}) => {
  const keywords = normalizeMainSearchQuery(query);
  if (dropdownOpen && activeIndex > 0) {
    const username =
      typeof sellers[activeIndex - 1]?.username === 'string'
        ? sellers[activeIndex - 1].username.trim()
        : '';
    if (username) {
      return { type: 'seller', seller: username };
    }
  }
  return { type: 'keywords', keywords };
};

export const mergeKeywordSearchParams = (currentSearchParams = {}, rawQuery) => {
  const keywords = normalizeMainSearchQuery(rawQuery);
  return {
    ...currentSearchParams,
    page: null,
    keywords: keywords || null,
  };
};

export const mergeSellerSearchParams = (currentSearchParams = {}, username) => ({
  ...currentSearchParams,
  seller: username,
  keywords: null,
  page: null,
});

/**
 * Navbar/hero keyword-bar submit. `values.keywords` is the raw typed query
 * (one `@` strip happens here). `values.seller` wins and clears keywords.
 */
export const resolveKeywordBarSubmit = (currentSearchParams = {}, values = {}) => {
  if (values?.seller) {
    return mergeSellerSearchParams(currentSearchParams, values.seller);
  }
  return mergeKeywordSearchParams(currentSearchParams, values?.keywords);
};
